import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { templateSummarySchema } from '../schemas/templateApiSchemas';
import { templateKeys } from './templateKeys';

/** The tenant's template library, from SignCare. */
export function useTemplates(enabled = true) {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: templateKeys.list(tenantId ?? ''),
    queryFn: async ({ signal }) => {
      const raw = await apiClient.get(`api/v1/t/${tenantId}/templates`, { signal }).json();
      return templateSummarySchema.array().parse(raw);
    },
    enabled: enabled && !!tenantId,
    // Templates change when someone edits one, which is rare and always through this
    // app — a minute of staleness costs nothing and saves a request per panel open.
    staleTime: 60 * 1000,
  });
}
